/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import {
  toLoginRequest,
  toAuthProps,
  toChangeEmailRequest,
  toChangePasswordRequest,
  toActivateRequest,
  toPasswordRequest,
  toForgetRequest,
  toEmailRequest
} from './translator/auth'
import { toDoctorProps, toProfileRequest, toCalendarVisibleRequest, toCalendarBlockingRequest } from './translator/doctor'
import {
  PostLogin,
  GetRefresh,
  PutChangeEmail,
  PostForget,
  PutChangePassword,
  PostActivate,
  GetActivate,
  PostLogout,
  GetMe,
  PutProfile,
  PutCalendarVisible,
  PutCalendarBlocking,
  PostEmail,
  PostPassword
} from '@/infrastructure/network/Monitaro/requests/auth'
import { IAccountProps } from '@/entities/Account'
import { IDoctorProps } from '@/entities/Doctor'

export default class Auth extends MonitaroGatewayBase {
  async PostLogin(params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PostLogin(toLoginRequest(params)))
    return toAuthProps(auth)
  }

  async GetRefresh() {
    const { auth } = await this.apiClient.request(new GetRefresh())
    return toAuthProps(auth)
  }

  async PutChangeEmail(id: string, params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PutChangeEmail(id, toChangeEmailRequest(params)))
    return toAuthProps(auth)
  }

  async PostForget(params: IAccountProps) {
    const { forget } = await this.apiClient.request(new PostForget(toForgetRequest(params)))
    return forget
  }

  async PutChangePassword(id: string, params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PutChangePassword(id, toChangePasswordRequest(params)))
    return toAuthProps(auth)
  }

  async PostActivate(id: string, params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PostActivate(id, toActivateRequest(params)))
    return toAuthProps(auth)
  }

  async GetActivate(id: string, code: string) {
    const { name } = await this.apiClient.request(new GetActivate(id, code))
    return name
  }

  async PostLogout() {
    const { logout } = await this.apiClient.request(new PostLogout())
    return logout
  }

  async GetMe() {
    const { doctor } = await this.apiClient.request(new GetMe())
    return toDoctorProps(doctor)
  }

  async PutProfile(params: IDoctorProps, options?: { includeAreas?: boolean }) {
    const { doctor } = await this.apiClient.request(new PutProfile(toProfileRequest(params, options)))
    return toDoctorProps(doctor)
  }

  async PutCalendarVisible(isCalendarVisible: boolean) {
    const { doctor } = await this.apiClient.request(new PutCalendarVisible(toCalendarVisibleRequest(isCalendarVisible)))
    return toDoctorProps(doctor)
  }

  async PutCalendarBlocking(isCalendarBlocking: boolean) {
    const { doctor } = await this.apiClient.request(new PutCalendarBlocking(toCalendarBlockingRequest(isCalendarBlocking)))
    return toDoctorProps(doctor)
  }

  async PostEmail(params: IAccountProps) {
    const { forget } = await this.apiClient.request(new PostEmail(toEmailRequest(params)))
    return forget
  }

  async PostPassword(params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PostPassword(toPasswordRequest(params)))
    return toAuthProps(auth)
  }
}
